import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "13",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#000",
      d: "M4.136 12.16q-1.125 0-2.005-.387-.876-.387-1.392-1.074A2.9 2.9 0 0 1 .182 9.09h1.432q.045.563.386.972.341.403.892.624.551.222 1.222.222.75 0 1.33-.261.58-.262.908-.728.33-.465.33-1.08 0-.64-.318-1.13-.318-.495-.932-.772-.615-.279-1.5-.279H3V5.41h.932q.693 0 1.216-.25.528-.25.824-.704.3-.455.3-1.069 0-.59-.26-1.028a1.8 1.8 0 0 0-.74-.682q-.471-.244-1.113-.244-.602 0-1.136.221-.529.216-.864.631a1.64 1.64 0 0 0-.364.989H.432q.034-.915.551-1.603A3.5 3.5 0 0 1 2.335.59 4.4 4.4 0 0 1 4.182.206q1.08 0 1.852.437a3.1 3.1 0 0 1 1.188 1.142q.414.71.414 1.534 0 .983-.517 1.676-.51.694-1.392.96v.091q1.103.183 1.722.938.62.75.62 1.858 0 .948-.518 1.705-.51.75-1.398 1.181-.885.432-2.017.432M14.188 12h-3.591V.364h3.75q1.692 0 2.897.699 1.205.693 1.847 1.994.642 1.295.642 3.102 0 1.819-.648 3.13a4.6 4.6 0 0 1-1.886 2.012Q15.96 12 14.187 12Zm-2.182-1.25h2.09q1.444 0 2.393-.557a3.43 3.43 0 0 0 1.414-1.585q.466-1.029.466-2.449 0-1.41-.46-2.426a3.4 3.4 0 0 0-1.375-1.568q-.916-.552-2.278-.551h-2.25z"
    }, null, -1)
  ])))
}
export default { render: render }